module.exports = __webpack_public_path__ + "media/apps/mitch-ios-5-0c0ca7f7.png";